enum LangType {
    EN = "en",
    ZH_CN = "zh_cn",
}

enum StaticConst {
    title = "title",
    chinese = "chinese",
    english = "english",
    home = "home",
    work = "work",
    privacy = "privacy",
    why = "why",
    innovitive = "innovitive",
    creative = "creative",
    ongoing = "ongoing",
    view = "view",
    contact = "contact",
    email = "email",
    phone = "phone",
    address = "address",
}

class LangEntity {
    statics: Map<string, string>;

    constructor() {
        this.statics = new Map();
    }

    Static_Add(key: string, value: string) {
        this.statics.set(key, value);
    }

    Static_Get(key: string): string {
        return this.statics.get(key) || "";
    }
}

let lang: LangType;
let all: Map<LangType, LangEntity>;

function Init() {
    if (all != undefined) {
        return;
    }
    const storedLang = localStorage.getItem("lang") as LangType | null;
    lang = storedLang && Object.values(LangType).includes(storedLang as LangType)
        ? (storedLang as LangType)
        : LangType.EN;
    all = new Map();

    let zh_cn: LangEntity = new LangEntity();
    let en: LangEntity = new LangEntity();
    all.set(LangType.ZH_CN, zh_cn);
    all.set(LangType.EN, en);

    en.Static_Add(StaticConst.title, "9E Games");
    en.Static_Add(StaticConst.chinese, "中");
    en.Static_Add(StaticConst.english, "EN");
    en.Static_Add(StaticConst.home, "Home");
    en.Static_Add(StaticConst.work, "Game Works");
    en.Static_Add(StaticConst.privacy, "Privacy Policy");
    en.Static_Add(StaticConst.why, "Why Choose Us");
    en.Static_Add(StaticConst.innovitive, "Innovitive Game Design");
    en.Static_Add(StaticConst.creative, "Creative Expertise");
    en.Static_Add(StaticConst.ongoing, "Ongoing Support And Updates");
    en.Static_Add(StaticConst.view, "View All");
    en.Static_Add(StaticConst.contact, "Contact Us");
    en.Static_Add(StaticConst.email, "Email");
    en.Static_Add(StaticConst.phone, "Phone");
    en.Static_Add(StaticConst.address, "Address");

    zh_cn.Static_Add(StaticConst.title, "久忆");
    zh_cn.Static_Add(StaticConst.chinese, "中");
    zh_cn.Static_Add(StaticConst.english, "EN");
    zh_cn.Static_Add(StaticConst.home, "首页");
    zh_cn.Static_Add(StaticConst.work, "案例");
    zh_cn.Static_Add(StaticConst.privacy, "隐私政策");
    zh_cn.Static_Add(StaticConst.why, "为什么选择我们");
    zh_cn.Static_Add(StaticConst.innovitive, "创新的游戏设计");
    zh_cn.Static_Add(StaticConst.creative, "创造性的专业知识");
    zh_cn.Static_Add(StaticConst.ongoing, "持续的支持和更新");
    zh_cn.Static_Add(StaticConst.view, "更多作品");
    zh_cn.Static_Add(StaticConst.contact, "联系我们");
    zh_cn.Static_Add(StaticConst.email, "邮箱");
    zh_cn.Static_Add(StaticConst.phone, "电话");
    zh_cn.Static_Add(StaticConst.address, "地址");
}

Init();

function Lang_Current() : LangType {
    return lang;
}

function Lang_Set(langType: LangType) {
    lang = langType;
    localStorage.setItem("lang", lang);
}

function Static_Get(key: string): string {
    return all.get(lang)?.Static_Get(key) || "";
}

export default {
    LangType: LangType,
    StaticConst: StaticConst,
    Lang_Current,
    Lang_Set,
    Static_Get
}